import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
  getMyInvoicesApi,
  getCurrentInvoiceApi,
  getSystemSettingApi,
  submitPaymentApi,
  getSubscriptionDetailsApi,
} from "../../api/billingApi";

// Current Invoice
export const getCurrentInvoice = createAsyncThunk(
  "billing/currentInvoice",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCurrentInvoiceApi();

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Invoice History
export const getMyInvoices = createAsyncThunk(
  "billing/myInvoices",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getMyInvoicesApi();

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
// System Setting
export const getSystemSetting = createAsyncThunk(
  "billing/systemSetting",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSystemSettingApi();

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
// Submit Payment
export const submitPayment = createAsyncThunk(
  "billing/submitPayment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await submitPaymentApi(data);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// get Subscription Details
export const getSubscriptionDetails = createAsyncThunk(
  "billing/subscriptionDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionDetailsApi();

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  invoices: [],
  currentInvoice: null,
  subscription: null,
  setting: null,
  loading: false,
  error: null,
  success: false,
};

const billingSlice = createSlice({
  name: "billing",
  initialState,

  reducers: {
    clearBillingError: (state) => {
      state.error = null;
    },

    resetBillingSuccess: (state) => {
      state.success = false;
    },
  },

  extraReducers: (builder) => {
    builder

      // Current Invoice
      .addCase(getCurrentInvoice.pending, (state) => {
        state.loading = true;
      })

      .addCase(getCurrentInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.currentInvoice = action.payload.invoice;
      })

      .addCase(getCurrentInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // My Invoices
      .addCase(getMyInvoices.fulfilled, (state, action) => {
        state.invoices = action.payload.invoices;
      })

      // System Setting
      .addCase(getSystemSetting.fulfilled, (state, action) => {
        state.setting = action.payload.setting;
      })

      // Submit Payment
      .addCase(submitPayment.fulfilled, (state) => {
        state.success = true;
      })

      .addCase(getSubscriptionDetails.fulfilled, (state, action) => {
        state.subscription = action.payload.subscription;
      });
  },
});

export const { clearBillingError, resetBillingSuccess } = billingSlice.actions;

export default billingSlice.reducer;
